const e = { aria_label: "Search", clear: "Clear", placeholder_article: "Search Help Center", placeholder_header: "Search for Articles" }, r = {
  searcher: e
};
export {
  r as default,
  e as searcher
};
//# sourceMappingURL=help-center-articles-search33.js.map
